import { isEmpty } from 'lodash-es';
import { useFormContext } from 'react-hook-form';
import { LuGlobe } from 'react-icons/lu';
import { WsAutoComplete, WsColors } from 'wisestep-base';

import WsFilterProps from '../models/WsFilterProps';

import WsAccordion from './WsAccordion';

const SourceFilter = ({ name, defaultValue = [], showAccordionIcon = false }: WsFilterProps) => {
  const { setValue } = useFormContext();
  //need to be updated to new list
  const jobBoards: string[] = [
    'DICESEARCH',
    'CAREERBUILDERSEARCH',
    'CWJOBSSEARCH',
    'MONSTERUS',
    'MONSTERUKEU',
    'LINKEDIN',
    'TECHFETCHSEARCH',
    'JOBSERVE',
    'CVUPLOAD_LOCAL',
    'CVUPLOAD_EMAIL',
    'ZIPRECRUITER',
    'NAUKARI',
    'CAREER_PAGE_APPLY',
    'NAUKARI',
  ];
  const onSourceNameSelection = (SourceNames: string[]) => setValue(name, SourceNames);
  return (
    <WsAccordion
      title="Source"
      {...(showAccordionIcon && { startIcon: <LuGlobe color={WsColors.TertiaryShades800} /> })}
    >
      <WsAutoComplete
        size="small"
        onTagsChange={onSourceNameSelection}
        placeholder="Add by source"
        initialValue={defaultValue}
        optionsInStringArray={jobBoards}
        multiple={true}
        freeSolo={false}
        name={name}
        resetValue={isEmpty(defaultValue)}
      />
    </WsAccordion>
  );
};
export default SourceFilter;
